exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "li {\n  list-style-type: none;\n  color: #eae8e8;\n}\n\nul {\n  background-color: #6d6d6d;\n  padding: 4px 10px;\n  border-radius: 5px;\n  height: 300px;\n  overflow: scroll;\n  width: 500px;\n}\n\nh3 {\n  margin-top: 20px;\n  font-family: 'Oleo Script Swash Caps', cursive;\n  color: #eae8e8;\n}\n\napp-load-saved-beat {\n  display: inline-block;\n}\n\n@media screen and (max-width: 580px) {\n  li {\n    font-size: 12px;\n  }\n\n  ul {\n    height: 150px;\n    width: 520px;\n  }\n}\n\n@media screen and (max-width: 375px) {\n  ul {\n    height: 150px;\n    width: 300px;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/BREA/Desktop/drum-machine/src/app/list-stored-beats/list-stored-beats.component.css
// module id = ../../../../../src/app/list-stored-beats/list-stored-beats.component.css
// module chunks = main